import React from 'react';

const sortOptions = [
    { value: 'createdAt', label: 'Created date' },
    { value: 'price', label: 'Price' },
    { value: 'area', label: 'Area' },
    { value: 'title', label: 'Title' },
];

function PropertiesAdvancedFilters({ isOpen, filters, onChange, onReset, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="crm-drawer-overlay" onClick={onClose}>
            <div className="crm-drawer-panel" onClick={(e) => e.stopPropagation()}>
                <div className="crm-drawer-header">
                    <h3>Advanced Filters</h3>
                    <button className="crm-btn crm-btn-secondary crm-btn-sm" onClick={onClose}>Close</button>
                </div>
                <div className="crm-drawer-body">
                    <div className="crm-form-group">
                        <label className="crm-label">City</label>
                        <input
                            className="crm-input"
                            value={filters.city}
                            onChange={(e) => onChange('city', e.target.value)}
                            placeholder="City"
                        />
                    </div>
                    <div className="crm-form-grid">
                        <div className="crm-form-group">
                            <label className="crm-label">Min Price</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={filters.minPrice}
                                onChange={(e) => onChange('minPrice', e.target.value)}
                                placeholder="Min Price"
                            />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Max Price</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={filters.maxPrice}
                                onChange={(e) => onChange('maxPrice', e.target.value)}
                                placeholder="Max Price"
                            />
                        </div>
                    </div>
                    <div className="crm-form-grid">
                        <div className="crm-form-group">
                            <label className="crm-label">Min Area</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={filters.minArea}
                                onChange={(e) => onChange('minArea', e.target.value)}
                                placeholder="Min Area"
                            />
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Max Area</label>
                            <input
                                className="crm-input"
                                type="number"
                                value={filters.maxArea}
                                onChange={(e) => onChange('maxArea', e.target.value)}
                                placeholder="Max Area"
                            />
                        </div>
                    </div>
                    <div className="crm-form-group">
                        <label className="crm-label">Tags (comma)</label>
                        <input
                            className="crm-input"
                            value={filters.tags}
                            onChange={(e) => onChange('tags', e.target.value)}
                            placeholder="premium, corner, garden"
                        />
                    </div>
                    <div className="crm-form-grid">
                        <div className="crm-form-group">
                            <label className="crm-label">Sort</label>
                            <select
                                className="crm-select"
                                value={filters.sort}
                                onChange={(e) => onChange('sort', e.target.value)}
                            >
                                {sortOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="crm-form-group">
                            <label className="crm-label">Direction</label>
                            <select
                                className="crm-select"
                                value={filters.dir}
                                onChange={(e) => onChange('dir', e.target.value)}
                            >
                                <option value="desc">Descending</option>
                                <option value="asc">Ascending</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="crm-drawer-footer">
                    <button className="crm-btn crm-btn-secondary" onClick={onReset}>Reset</button>
                    <button className="crm-btn crm-btn-primary" onClick={onClose}>Apply</button>
                </div>
            </div>
        </div>
    );
}

export default PropertiesAdvancedFilters;
